export const cxChatBannerBodyText =
  'Your subscription includes Live Chat & Chatbot for your website -';
export const cxChatBannerLinkText = 'Start set-up today';
